<div [ngSwitch]="sbcType">
  <a [href]="url" *ngSwitchCase="'cmcrstFunction'" target="_blank">
    {{ssoLabel || 'Summary of Benefits and Coverage'}}
  </a>
  <a [href]="url" *ngSwitchCase="'aemContentPath'" target="_blank">
    {{ssoLabel || 'Summary of Benefits and Coverage'}}
  </a>
  <a [href]="url" *ngSwitchCase="'cmodContentPath'" target="_blank">
    {{ssoLabel || 'Summary of Benefits and Coverage'}}
  </a>
</div>

